import * as React from "react";
import { createRoot } from "react-dom/client";
import { Providers } from "@/components/providers";
import { App } from "./router";
import "./app/globals.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>,
);
